export const REDUCER_NAME = "nationalTeamCompetitionTable";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONTABLE = `${REDUCER_NAME}/SET_COMPETITIONTABLE`;
export const RESET_COMPETITIONTABLE = `${REDUCER_NAME}/RESET_COMPETITIONTABLE`;

export const getKey = (data) => `${data.competitionId}`;
